import * as yup from 'yup'

import { ResourceModel, makeOptions } from '@modules/resource/resource.module'

import {
	bankNames,
	counties,
	countries,
	employmentSchemes,
	genders,
	heardAboutSources,
	nationalities,
	pronouns,
	foodSafetyCertificateLevels,
} from '@server/constants'

import userStatuses from '@server/constants/statuses/user-statuses'

const UserModel = new ResourceModel({
	resourceKey: 'user',
},[
	{
		key: 'status',
		label: 'Status',
		type: 'select',
		fieldProps: {
			// TODO: extend makeOptions function to correctly make options from objects
			// if has label && value, use object, if has only label object is value
			options: userStatuses.map(status => ({
				label: status.label,
				value: status,
			})),
		},
		defaultValue: userStatuses.find(s => s.key === 'active'),
		toCSV: {
			formatValue: val => val && val.label,
		},
	},
	{
		key: 'email',
		label: 'E-mail Address',
		type: 'email',
		required: 'always', // always, never, conditionally, auto
		toCSV: {
			include: 'always', // always, never, auto
		},
	},
	{
		key: 'name',
		type: 'object',
		label: 'Name',
		children: [
			{
				key: 'title',
				label: 'Title',
				type: 'select',
				validator: yup.string(), // TODO: enum pronouns
				required: 'never',
				fieldProps: {
					options: makeOptions(pronouns),
				},
			},
			{
				key: 'first',
				label: 'First Name',
				type: 'text',
				validator: yup.string().min(2).max(50),
				required: 'always',
			},
			{
				key: 'middle',
				label: 'Middle Name',
				type: 'text',
				validator: yup.string(),
				required: 'never',
			},
			{
				key: 'last',
				label: 'Last Name',
				type: 'text',
				validator: yup.string().min(2).max(50),
				required: 'always',
			},
		],
	},
	{
		key: 'payrollNo',
		label: 'Payroll No.',
		type: 'number',
		required: 'never',
	},
	{
		key: 'password',
		label: 'New Password',
		type: 'password',
		private: true,
		required: 'conditional',
		validator: ({ isNew }) => {
			const base = yup.string().min(8);
			return isNew ? base.required() : base;
		},
		toCSV: {
			include: 'never',
		},
		fieldProps: {
			autoComplete: 'new-password',
		}
		// fieldProps: {
		// 	show: ({ isNew }) => isNew || isNew === undefined,
		// },
		// fieldProps: {
		// 	// TODO: abstact this show: isNew function? 
		// 	show: ({isNew}) => isNew,
		// }
	},
	{
		key: 'passwordConfirm',
		label: 'Confirm New Password',
		type: 'password',
		private: true,
		validator: yup.string().when('password', {
			is: (password) => password && password.length,
			then: yup.string().required('Confirm New Password is required').oneOf([yup.ref('password')], 'Passwords do not match')
		}),
		fieldProps: {
			show: ({values}) => values && values.password && values.password.length,
		},
		required: 'conditional',
		toCSV: {
			include: 'never',
		},
	},
	// TODO: decide if i need lastLogin
	// {
	// 	key: 'lastLogin',
	// 	type: 'date',
	// 	readOnly: true,
	// }	
]);

// TODO: remove window instances after development
window.UserModel = UserModel;

export default UserModel;


// WEBPACK FOOTER //
// ./src/modules/user/models/user.model.js